export default class SDUnrecaptured1250 {
  l18 = (): number | undefined => undefined
}
